import { LabelText, ValueText } from 'components/ShiftModal/src/views/DetailView/DetailView.styled';
import { Flex } from 'components/Flex';
import { FC } from 'react';

import {
  formatTime,
  formatUnpaidBreakTime,
} from 'components/ShiftModal/src/views/DetailView/TimesheetsTab/TimesheetsTab.utils';

import { MountTransition } from 'routes';
import { useTranslation } from 'hooks/useTranslation';
import { DetailViewInnerHeader } from 'pages/LocationSettingsPage/PositionsAllocation/RemovePositionModal/views/OpenShifts/DetailView/DetailTabView/DetailTabView';
import { IGeneralTabProps } from 'components/ShiftModal/src/views/DetailView/GeneralTab/GeneralTab.types';

export const shiftModalGeneralTabValueTextMarginLeft = 16;
export const shiftModalGeneralTabFormItemVerticalMargin = 24;

export const GeneralTab: FC<IGeneralTabProps> = ({ data }): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Flex flexDirection="column" childMarginBottom="40px" flex="1">
      <MountTransition>
        <DetailViewInnerHeader data={data} />

        <Flex flexDirection="column" padding="32px" childMarginBottom="32px">
          <Flex>
            <Flex flexDirection="column" width="240px">
              <LabelText>{t('shift_modal:TOTAL_PAID_DURATION')}</LabelText>
              <ValueText marginLeft={shiftModalGeneralTabValueTextMarginLeft}>
                {data.fetchOrder!.noShow
                  ? '0 hrs'
                  : formatTime(data.fetchOrder!.totalDuration ?? 0)}
              </ValueText>
            </Flex>

            {data.fetchOrder!.orderSchedule.breakTime && (
              <Flex flexDirection="column">
                <LabelText>{t('shift_modal:UNPAID_BREAK_TIME')}</LabelText>
                <ValueText marginLeft={shiftModalGeneralTabValueTextMarginLeft}>
                  {formatUnpaidBreakTime(data.fetchOrder!.orderSchedule.breakTime)}
                </ValueText>
              </Flex>
            )}
          </Flex>

          {data.fetchOrder!.community && (
            <Flex flexDirection="column">
              <LabelText>{t('shift_modal:LOCATION')}</LabelText>
              <ValueText marginLeft={shiftModalGeneralTabValueTextMarginLeft}>
                {data.fetchOrder!.community.name}
              </ValueText>
              {data.fetchOrder!.location && data.fetchOrder!.location.fullAddress && (
                <ValueText marginLeft={shiftModalGeneralTabValueTextMarginLeft}>
                  {data.fetchOrder!.location.fullAddress}
                </ValueText>
              )}
            </Flex>
          )}

          {data.fetchOrder!.description && (
            <Flex flexDirection="column">
              <LabelText>{t('shift_modal:SHIFT_NOTES')}</LabelText>
              {data.fetchOrder!.description.split('\n').map((textSegment, i, { length }) => (
                <ValueText marginLeft={shiftModalGeneralTabValueTextMarginLeft}>
                  {textSegment}
                  {/** Add line break if not first or last text segment */}
                  {i > 0 && i < length - 1 && <br />}
                </ValueText>
              ))}
            </Flex>
          )}
        </Flex>
      </MountTransition>
    </Flex>
  );
};
